import * as React from 'react';

import DiscoDanceParty140 from './DiscoDanceParty140';

export const discoDanceParty140 = () => <DiscoDanceParty140 />;

export default {
    title: 'Illustration/DiscoDanceParty140',
    component: DiscoDanceParty140,
    parameters: {
        notes: "`import DiscoDanceParty140 from 'box-ui-elements/es/illustration/DiscoDanceParty140';`",
    },
};
